module.exports = __webpack_public_path__ + "img/bg.7f1509b3.png";